import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/** Stripe cancel_url landing. The cart is untouched, so the user can retry. */
export function CheckoutCancelPage() {
  return (
    <div className="mx-auto max-w-md py-16">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 py-10 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
            <XCircle className="h-6 w-6" />
          </div>
          <div>
            <h1 className="font-display text-xl font-bold">Checkout cancelled</h1>
            <p className="mx-auto mt-2 max-w-xs text-sm text-muted-foreground">
              No payment was taken. Your cart is still saved — pick up where you left off
              whenever you're ready.
            </p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" asChild>
              <Link to="/plans"><ArrowLeft className="h-4 w-4" /> Keep browsing</Link>
            </Button>
            <Button asChild><Link to="/cart">Back to cart</Link></Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
